import { type ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { GET_COMPONENT_SOURCES_BY_ID } from '@api/queries/components';
import {
    ComponentDetailsCard,
    fromComponent,
} from '@components/ComponentDetailsCard';
import { type ComponentProps } from '../../models/ComponentProps';

export function ComponentDetailsTab({ component }: ComponentProps): ReactNode {
    const { data, loading } = useQuery(GET_COMPONENT_SOURCES_BY_ID, {
        variables: { componentId: component.id },
    });

    const sourcesData =
        data?.componentsWithSources.edges[0]?.node.sourcesData ?? [];

    return (
        <ComponentDetailsCard
            data={fromComponent(component, sourcesData)}
            sourcesLoading={loading}
        />
    );
}
